import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Mic, ArrowRight } from "lucide-react";

const HOST_IMG = "/dennis.jpg";

export default function HostTeaser() {
  return (
    <section id="host-teaser" className="py-16 px-5 sm:px-8 bg-[#0C1424] grain" data-testid="host-teaser">
      <div className="max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="grid sm:grid-cols-[160px_1fr] gap-6 sm:gap-8 items-center"
        >
          <div className="relative mx-auto sm:mx-0 w-40">
            <div className="absolute -inset-4 rounded-full bg-[#0066FF]/20 blur-2xl" />
            <div className="relative rounded-2xl overflow-hidden border border-[#0066FF]/30">
              <img
                src={HOST_IMG}
                alt="Dennis Haymon, host and producer"
                className="w-full aspect-[3/4] object-cover"
                data-testid="host-teaser-photo"
              />
            </div>
          </div>

          <div>
            <div className="flex items-center gap-2 mb-3 font-mono2 text-xs tracking-[0.3em] uppercase text-[#0066FF]">
              <Mic className="h-4 w-4" /> Your Host
            </div>
            <h2 className="font-display text-3xl sm:text-4xl uppercase leading-none">
              Dennis <span className="text-[#0066FF] blue-glow">Haymon</span>
            </h2>
            <p className="mt-4 text-[#CBD5E1] leading-relaxed max-w-xl">
              Born and raised in urban St. Louis, Dennis is a Senior Elder, community activist, published author,
              and Certified Youth Gang Specialist — turning pain into purpose and stories into real change.
            </p>
            <Link
              to="/about"
              data-testid="host-teaser-link"
              className="mt-5 inline-flex items-center gap-2 rounded-full border border-[#FF6B00] text-[#FF6B00] hover:bg-[#FF6B00] hover:text-[#050B14] transition-colors px-6 py-2.5 font-cond font-bold uppercase tracking-wide text-sm"
            >
              Read His Story <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
